import { ReportsModal } from '@/shared/components/reports-modal'
import { FiClock, FiFile, FiUser } from 'react-icons/fi'
import { useLoaderData } from 'react-router-dom'

export const EmployeeReports = () => {
  const { data: companyReportColumns } = useLoaderData()

  const reportOptions = [
    {
      label: 'Tabla de personas',
      description:
        'Descarga la información de la tabla de personas. Puedes seleccionar las columnas',
      value: 'employee',
      icon: FiUser,
      columns: companyReportColumns
    },
    {
      label: 'Historial de contratos',
      description:
        'Descarga la lista de contratos anteriores de la persona',
      value: 'employee_contract',
      icon: FiClock,
      columns: []
    },
    {
      label: 'Listado de documentos',
      description:
        'Descarga el listado de documentos asociados a las personas.',
      value: 'employee_contract_attachments',
      icon: FiFile,
      columns: []
    }
  ]

  return <ReportsModal reportOptions={reportOptions} />
}
